import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Plane } from "@babylonjs/core/Maths/math.plane";

export default class CreateObjectDragger {

  constructor(props) {
    this.state = props;

    this.draggingObject = null;

    if (this.state.draggingMesh) {
      this.state.draggingMesh.isVisible = false;
    }
  }

  onPointerMove(x, y) {
    if (this.draggingObject) {
      this.state.scene.pointerX = x;
      this.state.scene.pointerY = y;
      this.draggingObject.position.copyFrom(this.calculateWorldPos());
    }
  }

  onPointerUp() {
    if (this.draggingObject) {
      if (this.state.onDragEnd) {
        const scenePick = this.getScenePick();
        this.state.onDragEnd(this.draggingObject, scenePick);
      }

      this.draggingObject = null;
    }
  }

  onPointerOut() {
    if (this.state.draggingMesh) {
      this.draggingObject = this.state.draggingMesh;
    } else if (this.state.draggingMeshFn) {
      this.draggingObject = this.state.draggingMeshFn();
    }

    this.draggingObject.isPickable = false;
    this.draggingObject.isVisible = true;
    this.draggingObject.position.copyFrom(this.calculateWorldPos());
  }

  calculateWorldPos() {
    const scenePick = this.getScenePick();
    const distance = Plane.SignedDistanceToPlaneFromPositionAndNormal(
      this.state.scene.activeCamera.position,
      scenePick.ray.direction,
      new Vector3.Zero());
    const worldPos = scenePick.ray.direction.scaleAndAddToRef(distance, scenePick.ray.origin);
    return worldPos;
  }

  getScenePick() {
    const scenePick = this.state.scene.pick(this.state.scene.pointerX, this.state.scene.pointerY);
    return scenePick;
  }
}